import React, { useCallback, useEffect, useState, useContext } from 'react'
import { t } from "i18next";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
  } from "react-device-detect";
import PageHeader from "../../components/PageHeader";
import TabContainer from '../../components/TabContainer/TabContainer';
import SettingTab from './SettingsTab';
import PreferenceSettings from './PreferenceSetting/PreferenceSetting';
import ProfileSettings from './ProfileSettings/ProfileSettings';
import AvailableResource from './AvailableResource/AvailableResource';
import {
  userProfile,
  getSignatureImage,
  userPreference
} from "../../service/UserService";
import userContext from '../../context/users/UserContext';
import ChangePassword from '../ChangePassword/ChangePassword';
import { USERTYPES } from '../../constants/Constants';
import loaderContext from '../../context/loader/LoaderContext';
import ContactDetails from './ContactDetails/ContactDetails';


const AccountAndSettings = () => {
    const [totalTabs, setTotalTabs] = useState(2);
    const [preferenceData, setPreferenceData] = useState({});
  const [showPreferenceTab, setShowPreferenceTab] = useState(false);
  const [contactDetailsData, setContactDetailsData] = useState({});
  const[showContactDetailsTab, setShowContactDetailsTab] = useState(false);
    const [advViewerUser, setAdvanceViewerUser] = useState(false);
    const [weasisViewerUser, setWeasisViewerUser] = useState(false);
    const [infinitViewerUser, setInfinitViewerUser] = useState(false);
    const { roles, authenticated, loadByUsername, userId } = useContext(userContext);
    const {ref, setLoaderRunning} = useContext(loaderContext);
    const tabDetails = () =>{

    let items = [
        {
          selectedKey: "1",
          tabName: `${t("account-and-settings.profile")}`,
          tabKeyContain: (
            <SettingTab
              tabName={t("account-and-settings.profile")}
              subtitle={t("sub-title.user.profile-settings")}
            />
          ),
          tabValueContain:
            <ProfileSettings key="1"
            />
        },
        {  selectedKey: "2",
          tabName: `${t("account-and-settings.password")}`,
          tabKeyContain: (
            <SettingTab
              tabName={t("account-and-settings.password")}
              subtitle={t("sub-title.user.password-setting")}
            />
          ),
          tabValueContain:
            <ChangePassword key="2" />
        },
    ]
    
    if(showPreferenceTab){
      items.push({
        selectedKey: "3",
        tabName: `${t("account-and-settings.preference")}`,
        tabKeyContain: (
          <SettingTab
            tabName={t("account-and-settings.preference")}
            subtitle={t("sub-title.user.viewer-preference")}
          />
        ),
        tabValueContain:
          <PreferenceSettings key="3"
            preferenceData={preferenceData}
            loggedInUserId= {userId}
            loggedInUserRole= {roles[0]}
            advViewerUser={advViewerUser}
            weasisViewerUser={weasisViewerUser}
            infinitViewerUser={infinitViewerUser}
          />
      })
      }
      if(showContactDetailsTab){
        items.push({
          selectedKey: showPreferenceTab ? "4" : "3",
          tabName: `${t("account-and-settings.contact-details")}`,
          tabKeyContain: (
            <SettingTab
              tabName={t("account-and-settings.contact-details")}
              subtitle={t("sub-title.user.contact-details")}
            />
          ),
          tabValueContain:
            <ContactDetails key="4"
            // contactDetailsData={contactDetailsData}
            // loggedInUserId= {userId}
            // loggedInUserRole= {roles[0]} 
            />
        })
      }
    return items;
  }

  const handleTabs = () => {


    console.log("Handle Tabs Called", { roles, advViewerUser });

    console.log("current user role : ", roles[0], advViewerUser);
    if (roles[0] == USERTYPES.TYPIST || roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.ADMIN ) {
      if(roles[0] !== USERTYPES.TYPIST)
        setShowPreferenceTab(true);
      else
        setShowPreferenceTab(false);
      setShowContactDetailsTab(false);
      setTotalTabs(3);
      
    }
    else if (roles[0] == USERTYPES.FIRMDOCTOR) {
      setShowPreferenceTab(true);
      setShowContactDetailsTab(true);
      setTotalTabs(4);
    }
    else {
        setShowPreferenceTab(false);
        setShowContactDetailsTab(true);
        setTotalTabs(3);
    }
  }
  






    const getUserPreference = async () => {
        try{setLoaderRunning(true);
        ref.current.continuousStart();
        const response = await userPreference();
        if (response.status === 200 && response.data.result === "SUCCESS") {
          setLoaderRunning(false);
          ref.current.complete();
          console.log(response);
         setPreferenceData({
          ...response.data.data.userPreference,
          twoMonitorEnabled: response.data.data.userPreference?.twoMonitorEnabled || false
          });

          console.log("preference data :", preferenceData);
          setAdvanceViewerUser(response.data.data.advViewerUser);
          setWeasisViewerUser(response.data.data.weasisViewerUser);
          setInfinitViewerUser(response.data.data.infinitViewerUser);
        }else{
          setLoaderRunning(false);
          ref.current.complete();
        }}catch(e){
          setLoaderRunning(false);
          ref.current.complete();
        }
        
  };
  

  // const getUserProfile = async () => {
  //   let response = await userProfile();
  //   if (response.status === 200 && response.data.result === "SUCCESS") {
  //     setContactDetailsData(response.data.data);
  //     console.log("contactDetailsData in AccountsAndSettings.jsx : ", contactDetailsData);
  //     // setValues({
  //     //   ...response.data.data,
  //     //   technicianContactList: response.data.data.technicianContactList,
  //     // });
  //   }
  // };




    useEffect(() => {
      if (!authenticated) {
        loadByUsername();
      }
    }, []);

    useEffect(() => {
      getUserPreference();
    }, [roles[0]]);

    useEffect(()=>{
      handleTabs();
    }, [advViewerUser]);

    console.log("---tabDetails ---",tabDetails());

    return (
        <>
                <div className="main-container-body">
                    {!isMobile && <PageHeader header="account-and-settings.title" />}
                    {/* <div style={{ height: !isMobile ? '92%' : '100%' }}> */}
                    <TabContainer
                    uniqueKey="acnt&stng_"
                    tabDetails={tabDetails()}
                    NoOfTabs={tabDetails()?.length}
                    onCancelClick={()=>{"on cancel click"}}
                    onSubmitClick={()=>{"on submit click"}}
                    onNextClick={()=>{"on next click"}}
                    onEditClick={()=>{"on edit click"}}
                    previousNextButton={false}
                    mobileTabHeader={t("account-and-settings.title")}
                    //breadCrumbItems = {breadCrumbItems}
                    // topButtons = {[]}
                    />
                </div>
                
            
        </>
    )

}

export default AccountAndSettings
